import { useCallback, useEffect, useState } from "react"

import AssetService from "services/AssetService"
import Color from "models/Color"
import toastMessages from "stores/toastMessages"
import { ISelectOption } from "components/Select/SelectSearch"
import { Guid } from "@/types"

export default function useColors(init?: boolean) {
    const [colors, setColors] = useState<Color[] | null>(null)
    const colorsObj = colors?.reduce((acc, color) => {
        acc[color.id] = color
        return acc
    }, {} as { [id: string]: Color })

    const fetchColors = useCallback(async(params: { ignoreCache?: boolean } = {}) => {
        setColors(null)
        try {
            const newColors = await AssetService.getColors(params)
            setColors(newColors)
            return newColors
        } catch(e) {
            toastMessages.showSystemError()
            setColors([])
            return []
        }
    }, [])

    useEffect(() => {
        if (init) {
            fetchColors()
        }
    }, [fetchColors, init])

    const fetchColorsIgnoreCache = useCallback(() => {
        return fetchColors({ ignoreCache: true })
    }, [fetchColors])

    const colorFilterOptions: ISelectOption<Guid, Color>[] | undefined = colors?.map(color => ({
        label: color.name,
        value: color.id,
        data: color,
    }), [])

    return {
        colors,
        colorsObj,
        colorFilterOptions,
        setColors,
        fetchColors,
        fetchColorsIgnoreCache,
    }
}
